export const useStyles = () => {
  return {
    root: {
      // Sits just below TutorialStepText/TutorialCompletionNotice, whose
      // panel is bottom-anchored at 100px (see ../sharedStyles.ts) — its
      // bottom edge stays fixed there regardless of the panel's own
      // (content-driven) height, so this offset only needs to clear that.
      position: 'fixed',
      bottom: 48,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 1000,
      background: 'rgba(28, 28, 34, 0.75)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      color: '#e2e4ed',
      borderRadius: '99px',
      paddingX: 2,
      textTransform: 'none',

      '&:hover': {
        background: 'rgba(28, 28, 34, 0.9)',
      },
    },
  };
};
